// Requests from an earlier sign-in/out attempt must not clear a newer session.
let generation = 0;
export const getSessionGeneration = () => generation;
export const beginSessionChange = () => ++generation;